import {
    Flex,
    Box,
    Accordion,
    AccordionButton,
    AccordionIcon,
    AccordionItem,
    AccordionPanel,
    Button,
    Text
} from "@chakra-ui/react";
import React, {useState, useEffect} from "react";
import { StyleSheet, css } from "aphrodite";
// import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { publicationDetails } from "./PublicationDetails";
import { fetchData } from 'actions/actions';

function PublicationsList() {

    const isMobile = useSelector(state => state.windowSize.isMobile);
    const dispatch = useDispatch();

    const journals = publicationDetails?.filter(publication => publication.type === 'journal');
    const conference = publicationDetails?.filter(publication => publication.type === 'conference');
    const patent = publicationDetails?.filter(publication => publication.type === 'patent');

    const [currentPageJr, setCurrentPageJr] = useState(1);
    const [currentPageCn, setCurrentPageCn] = useState(1);
    const [currentPagePt, setCurrentPagePt] = useState(1);
    const itemsPerPage = 5;

    useEffect(() => {
      // Dispatch the fetchData action when the component mounts
      dispatch(fetchData());
    }, [dispatch]); 

    // console.log('Data:', data)

    // Calculate indexes for pagination
    const indexOfLastItem = currentPageJr * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;

    //For conferences
    const indexOfLastItemCn = currentPageCn * itemsPerPage;
    const indexOfFirstItemCn = indexOfLastItemCn - itemsPerPage;

    //For patent
    const indexOfLastItemPt = currentPagePt * itemsPerPage;
    const indexOfFirstItemPt = indexOfLastItemPt - itemsPerPage;

    const currentJournals = journals?.slice(indexOfFirstItem, indexOfLastItem);
    const currentConference = conference?.slice(indexOfFirstItemCn, indexOfLastItemCn);
    const currentPatent = patent?.slice(indexOfFirstItemPt, indexOfLastItemPt);

    const totalPagesJr = Math.ceil(journals?.length / itemsPerPage);
    const totalPagesCn = Math.ceil(conference?.length / itemsPerPage);
    const totalPagesPt = Math.ceil(patent?.length / itemsPerPage);

    // Journal Pagination: 
    const handleNextPageJr = () => {
      if (currentPageJr < totalPagesJr) {
        setCurrentPageJr(currentPageJr + 1);
      }
    };

    const handlePrevPageJr = () => {
      if (currentPageJr > 1) {
        setCurrentPageJr(currentPageJr - 1);
      }
    };

    // Conference Pagination
    const handleNextPageCn = () => {
      if (currentPageCn < totalPagesCn) {
        setCurrentPageCn(currentPageCn + 1);
      }
    };

    const handlePrevPageCn = () => {
      if (currentPageCn > 1) {
        setCurrentPageCn(currentPageCn - 1);
      }
    };

    // Patent Pagination
    const handleNextPagePt = () => {
      if (currentPagePt < totalPagesPt) {
        setCurrentPagePt(currentPagePt + 1);
      }
    };

    const handlePrevPagePt = () => {
      if (currentPagePt > 1) {
        setCurrentPagePt(currentPagePt - 1);
      }
    };

    return (
      <>
        {publicationDetails ? (
          <Box className={css(styles.head)} minH="70vh">
            {/* Journals */}
            <Flex className={css(styles.container)}>
              JOURNALS
            </Flex>
            <Flex className={css(styles.accordion)}>
              <Accordion allowMultiple width='100%' defaultIndex={[0]}>
                {currentJournals?.map((publication, index) => (
                  <AccordionItem key={index}>
                    <AccordionButton>
                      <Box
                        as="span"
                        flex='1'
                        textAlign='left'
                        fontSize={20}
                        fontWeight='bold'
                      >
                        "{publication.title}"
                      </Box>
                      <AccordionIcon />
                    </AccordionButton>
                    <AccordionPanel pb={4} fontSize={16} textAlign={isMobile ? 'center' : 'left'}>
                      <Box>
                        <Box>
                          {publication.writers}"{publication.title}" {publication.conference} {publication.publicationDate}.
                          {publication.link && (
                            <> Preprint available: <a href={publication.link} target="_blank" rel="noopener noreferrer" style={{ color: "#315369", fontWeight: "bold" }}>{publication.link}</a></>
                          )}
                        </Box>
                      </Box>
                    </AccordionPanel>
                  </AccordionItem>
                ))}
              </Accordion>
            </Flex>
            {journals.length === 0 && (
                <Text textAlign='center' width='100%' fontWeight='bold'>
                    Journals Will Be Announced Soon, Stay Tuned!
                </Text>
            )}

            {/* Pagination Controls */}
            {journals.length > itemsPerPage && (
              <Flex justifyContent='center' mt={4} alignItems='center'>
                <Button onClick={handlePrevPageJr} disabled={currentPageJr === 1}>
                  Previous
                </Button>
                <Text mx={4}>
                  Page {currentPageJr} of {totalPagesJr}
                </Text>
                <Button onClick={handleNextPageJr} disabled={currentPageJr === totalPagesJr}>
                  Next
                </Button>
              </Flex>
            )}
            <hr /><hr />
            {/* Conference */}
            <Flex className={css(styles.container)}>
              CONFERENCES
            </Flex>
            <Flex className={css(styles.accordion)}>
              <Accordion allowMultiple width='100%' defaultIndex={[0]}>
                {currentConference?.map((publication, index) => (
                  <AccordionItem key={index}>
                    <AccordionButton>
                      <Box
                        as="span"
                        flex='1'
                        textAlign='left'
                        fontSize={20}
                        fontWeight='bold'
                      >
                        "{publication.title}"
                      </Box>
                      <AccordionIcon />
                    </AccordionButton>
                    <AccordionPanel pb={4} fontSize={16} textAlign={isMobile ? 'center' : 'left'}>
                      <Box>
                        <Box>
                          {publication.writers}"{publication.title}" {publication.conference} {publication.publicationDate}.
                          {publication.link && (
                            <> Preprint available: <a href={publication.link} target="_blank" rel="noopener noreferrer" style={{ color: "#315369", fontWeight: "bold" }}>{publication.link}</a></>
                          )}
                        </Box>
                      </Box>
                    </AccordionPanel>
                  </AccordionItem>
                ))}
              </Accordion>
            </Flex>
            {conference.length === 0 && (
                <Text textAlign='center' width='100%' fontWeight='bold'>
                    Conferences Will Be Announced Soon, Stay Tuned!
                </Text>
            )}


            {/* Pagination Controls */}
            {conference.length > itemsPerPage && (
              <Flex justifyContent='center' my={4} alignItems='center'>
                <Button onClick={handlePrevPageCn} disabled={currentPageCn === 1}>
                  Previous
                </Button>
                <Text mx={4}>
                  Page {currentPageCn} of {totalPagesCn}
                </Text>
                <Button onClick={handleNextPageCn} disabled={currentPageCn === totalPagesCn}>
                  Next
                </Button>
              </Flex>
            )}
            <hr /><hr />
            {/* Patents */}
            <Flex className={css(styles.container)}>
              PATENTS
            </Flex>
            <Flex className={css(styles.accordion)}>
              <Accordion allowMultiple width='100%' defaultIndex={[0]}>
                {currentPatent?.map((publication, index) => (
                  <AccordionItem key={index}>
                    <AccordionButton>
                      <Box
                        as="span"
                        flex='1'
                        textAlign='left'
                        fontSize={20}
                        fontWeight='bold'
                      >
                        "{publication.title}"
                      </Box>
                      <AccordionIcon />
                    </AccordionButton>
                    <AccordionPanel pb={4} fontSize={16} textAlign={isMobile ? 'center' : 'left'}>
                      <Box>
                        <Box>
                          {publication.writers}"{publication.title}" {publication.conference} {publication.publicationDate}.
                          {publication.link && (
                            <> Preprint available: <a href={publication.link} target="_blank" rel="noopener noreferrer" style={{ color: "#315369", fontWeight: "bold" }}>{publication.link}</a></>
                          )}
                        </Box>
                      </Box>
                    </AccordionPanel>
                  </AccordionItem>
                ))}
              </Accordion>
            </Flex>
            {patent.length === 0 && (
                <Text textAlign='center' width='100%' fontWeight='bold'>
                    Patents Will Be Announced Soon, Stay Tuned!
                </Text>
            )}


            {/* Pagination Controls */}
            {patent.length > itemsPerPage && (
              <Flex justifyContent='center' my={4} alignItems='center'>
                <Button onClick={handlePrevPagePt} disabled={currentPagePt === 1}>
                  Previous
                </Button>
                <Text mx={4}>
                  Page {currentPagePt} of {totalPagesPt}
                </Text>
                <Button onClick={handleNextPagePt} disabled={currentPagePt === totalPagesPt}>
                  Next
                </Button>
              </Flex>
            )}
            <hr /><hr />
            </Box>
        ) : (
          <Flex>
            Loading...
          </Flex>
        )}
      </>
      
      );
    }

const styles = StyleSheet.create({
    head: {
        maxWidth: '100vw',
        marginTop: 140
    },
    container: {
        maxWidth: '100%',
        justifyContent: 'center',
        fontSize: 24,
        margin: '1%',
        fontWeight: 'bolder',
        textShadow: '1px 1px gray',
    },
    accordion: {
        maxWidth: '100vw',
        textAlign: 'center',
        paddingBottom: 0,
        margin: '1%',
        fontSize: 20,
    },
    link:{
        fontWeight: 'bold',
        color: '#315369',
        ':hover': {
            textDecoration: 'underline'
        }
    }
});

export default PublicationsList